import * as React from "react"

export default ({ data, btnMore }: any) => {
    const descStr = data.body.length >= 100 ? `<p>${data.body.replace(/\<\/h\w\>/gi, '<br/>').replace(/\<\/?\w*\>/gi, '').substr(0, 100)}...</p>` : data.body;
    const cardClass = data.field_imgsmall.url ? 'card-image' : 'card'

    return (
        <div className={cardClass} data-aos="fade-up" data-aos-duration="800" data-aos-anchor-placement='center-bottom'>
            <a href={data.field_urlarticle}>
                <div className={`${cardClass}__image`}>
                    <img src={data.field_imgsmall.url} alt={data.field_imgsmall.title} title={data.field_imgsmall.title} />
                </div>
                <div className={`${cardClass}__content`}>
                    <h3 className={`${cardClass}__content-title`}>{data.field_titlemain}</h3>
                    <p className={`${cardClass}__content-text`} dangerouslySetInnerHTML={{ __html: descStr }}></p>

                </div>
                <div className={`${cardClass}__footer`}>
                    <div className={`${cardClass}__footer-info`}>
                        {/* <p>{data.author}</p> */}
                        <p className='light'>{data.format_date}</p>
                    </div>
                    <div className={`${cardClass}__footer-btn`}>
                        <span>{btnMore}</span>
                    </div>
                </div>
            </a>
        </div>
    )
}
